import {
  delLayout,
  addLayout,
  updateLayout,
  setDefaultShow,
  TDefaultShow,
  setDefaultFilters,
  TDefaultFilters,
  TLayoutItem,
} from '@redux/layouts/actions';
import { createSlice } from '@reduxjs/toolkit';
import { TFilterRequest } from 'components/rest/Filter/FilterContent';

export type Layouts = { [key: string]: TLayoutItem[] };
export type DefaultShows = {
  [key: string]: string[];
};
export type DefaultFilters = {
  [key: string]: TFilterRequest[];
};
export interface LayoutState {
  layouts: Layouts;
  defaultLayouts: Layouts;
  defaultShows: DefaultShows;
  defaultFilters: DefaultFilters;
}

const initialState: LayoutState = {
  layouts: {},
  defaultLayouts: {},
  defaultShows: {},
  defaultFilters: {},
};

export const layoutsSlice = createSlice({
  name: 'layouts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        setDefaultFilters,
        (state, { payload }: { payload: TDefaultFilters }) => {
          state.defaultFilters[payload.rootPath] = payload.filters;
        },
      )
      .addCase(
        setDefaultShow,
        (state, { payload }: { payload: TDefaultShow }) => {
          state.defaultShows[payload.rootPath] = payload.showColumns;
        },
      )
      .addCase(addLayout, (state, { payload }: { payload: TLayoutItem }) => {
        const keyLayout = payload?.isDefault
          ? 'defaultLayouts'
          : 'layouts';
        if (state[keyLayout][payload.rootPath]?.length) {
          state[keyLayout][payload.rootPath].push(payload);
        } else {
          state[keyLayout][payload.rootPath] = [payload];
        }
      })
      .addCase(updateLayout, (state, { payload }: { payload: TLayoutItem }) => {
        const keyLayout = payload?.isDefault
          ? 'defaultLayouts'
          : 'layouts';
        state[keyLayout][payload.rootPath] = state[keyLayout][
          payload.rootPath
        ].map((e) => (e.pathId === payload.pathId ? payload : e));
      })
      .addCase(delLayout, (state, { payload }: { payload: TLayoutItem }) => {
        state.layouts[payload.rootPath] = state.layouts[
          payload.rootPath
        ].filter(
          (layout: TLayoutItem) => layout.customPath !== payload.customPath,
        );
      });
  },
});

export default layoutsSlice.reducer;
